import type { ComponentType } from 'react'
import type { Theme } from 'baseui'

import IconFaceDelighted from '@/shared/icons/NewDesign/IconFaceDelighted'
import IconFaceFurious from '@/shared/icons/NewDesign/IconFaceFurious'
import IconFaceHappy from '@/shared/icons/NewDesign/IconFaceHappy'
import IconFaceNeutral from '@/shared/icons/NewDesign/IconFaceNeutral'
import IconFaceSad from '@/shared/icons/NewDesign/IconFaceSad'
import type { SDIconProps } from '@/shared/icons/SDIcon'

export type PollScore = 1 | 2 | 3 | 4 | 5

export interface PollScoreDefinition {
  score: PollScore
  Icon: ComponentType<SDIconProps>
  colorKey: `pollScore${PollScore}`
  softColorKey: `pollScore${PollScore}Soft`
}

export const pollColor = (theme: Theme, key: string) => (theme.colors as unknown as Record<string, string>)[key]

export const POLL_SCORES: PollScoreDefinition[] = [
  { score: 1, Icon: IconFaceFurious, colorKey: 'pollScore1', softColorKey: 'pollScore1Soft' },
  { score: 2, Icon: IconFaceSad, colorKey: 'pollScore2', softColorKey: 'pollScore2Soft' },
  { score: 3, Icon: IconFaceNeutral, colorKey: 'pollScore3', softColorKey: 'pollScore3Soft' },
  { score: 4, Icon: IconFaceHappy, colorKey: 'pollScore4', softColorKey: 'pollScore4Soft' },
  { score: 5, Icon: IconFaceDelighted, colorKey: 'pollScore5', softColorKey: 'pollScore5Soft' },
]

// Same rule as CommunicationBoardPolls::KEY_PATTERN in the API.
export const POLL_KEY_PATTERN = /^[a-z][a-z0-9-]{2,63}$/

export const POLL_KEY_ATTRIBUTE = 'data-poll'

export const isPollKey = (value: unknown): value is string => typeof value === 'string' && POLL_KEY_PATTERN.test(value)

export const newPollKey = (now = new Date()) => {
  const day = now.toISOString().slice(0, 10).replace(/-/g, '')
  const suffix = Math.random().toString(36).slice(2, 6).padEnd(4, '0')
  return `poll-${day}-${suffix}`
}
